import React from "react";
import CalculRentabiliteLocative from "../components/CalculRentabiliteLocative";
import { useSEO } from "../hooks/useSEO";

export default function CalculRentabiliteLocativePage() {
  useSEO({
    title: "Calculateur Rentabilité Locative Gratuit",
    description: "Calculez gratuitement la rentabilité de votre investissement locatif. Rendement brut, net et cash-flow pour optimiser votre investissement immobilier."
  });

  return <CalculRentabiliteLocative />;
}
